import Carousel from './Carousel.component';
export default Carousel;